var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wf-product-room-scene bg-white" },
    [
      _c("div", { staticClass: "d-flex" }, [
        _c("div", { staticClass: "pr-2 d-none d-lg-block" }, [
          _vm.selectedColor
            ? _c("div", [
                _c("img", {
                  staticClass:
                    "wf-product-swatch-multi-tile wf-product-room-scene-viewer custom-cursor-active-for-images",
                  attrs: {
                    id: "wf-product-swatch-viewer-image-desktop",
                    src:
                      _vm.isMultitile == true
                        ? _vm.getInstallImgUrl(
                            _vm.selectedInstallationMethod.name,
                            2000
                          )
                        : _vm.$helpers.getColorThumbnailImageUrl(
                            _vm.sellingStyleNumber,
                            _vm.selectedColor.colorNumber,
                            _vm.selectedProduct.productSizeImperial
                              ? _vm.selectedProduct.productSizeImperial
                                  .toLowerCase()
                                  .replace(/ /g, "")
                                  .replace("x", "-")
                                  .replace(/[a-zA-Z]/g, "")
                                  .replace("-", "x")
                              : null,
                            _vm.productData.productTypeDesc
                          ),
                    alt: "img"
                  },
                  on: {
                    click: function($event) {
                      return _vm.productRoomSceneViewModal("swatch")
                    },
                    error: _vm.handleThumbnailImageError,
                    load: _vm.applyPanzoom
                  }
                }),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "images-type-toggler-options" }, [
                    !_vm.hideSwatchMultiTileButtons.includes(
                      _vm.productData.productTypeDesc.toLowerCase()
                    )
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "wf-product-room-scene-swatch border-0 shadow",
                            class:
                              _vm.getViewOptions === "swatch"
                                ? "font-weight-bold"
                                : "color-light-grey",
                            on: {
                              click: function($event) {
                                _vm.toggleMode(false)
                                _vm.applyPanzoom()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.Details.Swatch.Label"
                                  ]
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.hideSwatchMultiTileButtons.includes(
                      _vm.productData.productTypeDesc.toLowerCase()
                    )
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "wf-product-room-scene-multiple border-0 shadow",
                            class:
                              _vm.getViewOptions === "multi"
                                ? "font-weight-bold"
                                : "color-light-grey",
                            on: {
                              click: function($event) {
                                _vm.toggleMode(true)
                                _vm.applyPanzoom()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.Details.MultiTile.Label"
                                  ]
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.videoURL
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "wf-product-room-scene-video border-0 shadow font-weight-bold",
                            on: {
                              click: function($event) {
                                return _vm.productRoomSceneViewModal("360Video")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.Details.Label.Video"
                                  ]
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wf-product-room-scene-view" },
          [
            _c(
              "div",
              {
                staticClass: "wf-product-room-scene-viewer d-none d-lg-block",
                class: _vm.isRug && _vm.viewMode === "swatch" ? "rug-image" : ""
              },
              [
                [
                  _vm.roomScenes.length > 1
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "\n                btn\n                wf-product-room-scene-viewer-button\n                wf-product-room-scene-viewer-button-previous\n              ",
                          attrs: { type: "button" },
                          on: { click: _vm.setPreviousRoomScene }
                        },
                        [
                          _c("span", {
                            staticClass:
                              "png-icon png-icon-icons-glyph--k-chevron-left",
                            attrs: { "aria-label": "Previous room scene" }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.roomScenes.length > 1
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "\n                btn\n                wf-product-room-scene-viewer-button\n                wf-product-room-scene-viewer-button-next\n              ",
                          attrs: { type: "button" },
                          on: { click: _vm.setNextRoomScene }
                        },
                        [
                          _c("span", {
                            staticClass:
                              "png-icon png-icon-icons-glyph--k-chevron-right",
                            attrs: { "aria-label": "Next room scene" }
                          })
                        ]
                      )
                    : _vm._e()
                ],
                _vm._v(" "),
                _c("div", { staticClass: "row h-100" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-9 pr-2 pl-0" },
                    [
                      _c("wf-load-image", {
                        attrs: {
                          "wrapper-class":
                            "wf-product-room-scene-viewer-display",
                          "image-class":
                            "wf-product-room-scene-viewer-image custom-cursor-active-for-images",
                          id: "wf-product-room-scene-viewer-image-desktop",
                          src: _vm.getRoomSceneImageUrl(
                            _vm.selectedRoomScene,
                            3000
                          ),
                          alt: "",
                          "image-load": _vm.applyPanzoom,
                          click: function(e) {
                            return _vm.productRoomSceneViewModal("roomscene")
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-3 p-0" },
                    [
                      _c("wf-load-image", {
                        attrs: {
                          "wrapper-class":
                            "wf-product-room-scene-viewer-display",
                          "image-class":
                            "wf-product-room-scene-viewer-image h-100",
                          src: _vm.getRoomSceneImageUrl(
                            _vm.selectedRoomScene && _vm.getNextRoomScene(),
                            3000
                          ),
                          alt: ""
                        }
                      })
                    ],
                    1
                  )
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "d-lg-none" }, [
              _c(
                "div",
                {
                  staticClass: "wf-product-room-scene-viewer",
                  class: {
                    "mb-4 bg-white":
                      _vm.viewMode === "swatch" || _vm.viewMode === "multi"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      class:
                        _vm.getViewOptions === "room" ? "" : "d-none d-lg-block"
                    },
                    [
                      _vm.roomScenes.length > 1
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "\n                    btn\n                    wf-product-room-scene-viewer-button\n                    wf-product-room-scene-viewer-button-previous\n                  ",
                              attrs: { type: "button" },
                              on: { click: _vm.setPreviousRoomScene }
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "png-icon png-icon-icons-glyph--k-chevron-left",
                                attrs: { "aria-label": "Previous room scene" }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.roomScenes.length > 1
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "\n                    btn\n                    wf-product-room-scene-viewer-button\n                    wf-product-room-scene-viewer-button-next\n                  ",
                              attrs: { type: "button" },
                              on: { click: _vm.setNextRoomScene }
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "png-icon png-icon-icons-glyph--k-chevron-right",
                                attrs: { "aria-label": "Next room scene" }
                              })
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _vm.getViewOptions === "swatch" ||
                  _vm.getViewOptions === "multi"
                    ? _c("img", {
                        staticClass:
                          "wf-product-swatch-viewer-display custom-cursor-active-for-images",
                        attrs: {
                          src:
                            _vm.getViewOptions === "swatch"
                              ? _vm.$helpers.getColorThumbnailImageUrl(
                                  _vm.sellingStyleNumber,
                                  _vm.selectedColor.colorNumber
                                )
                              : _vm.getInstallImgUrl(),
                          alt: "img"
                        },
                        on: {
                          error: _vm.handleImageError,
                          click: function($event) {
                            return _vm.productRoomSceneViewModal("swatch")
                          }
                        }
                      })
                    : _c("wf-load-image", {
                        attrs: {
                          "wrapper-class":
                            "wf-product-room-scene-viewer-display",
                          "image-class":
                            "wf-product-room-scene-viewer-image custom-cursor-active-for-images",
                          src: _vm.getRoomSceneImageUrl(
                            _vm.selectedRoomScene,
                            3000
                          ),
                          alt: "",
                          click: function(e) {
                            return _vm.productRoomSceneViewModal("roomscene")
                          }
                        }
                      })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("pc-view-options", {
              attrs: { installationMethods: _vm.installationMethods },
              on: {
                "view-option-changed": _vm.handleViewOptionChanged,
                "install-option-changed": _vm.handleInstallationMethodClick
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "px-4 wf-product-room-scene-image-pagination",
                class: _vm.getViewOptions === "room" ? "" : "d-none d-lg-block"
              },
              [
                _c(
                  "ul",
                  {
                    staticClass: "wf-product-room-scene-image-pagination-list"
                  },
                  _vm._l(_vm.roomScenes, function(roomScene, index) {
                    return _c(
                      "li",
                      {
                        key: roomScene.data,
                        staticClass:
                          "wf-product-room-scene-image-pagination-item"
                      },
                      [
                        _c("button", {
                          staticClass:
                            "btn wf-product-room-scene-image-pagination-item-button",
                          class:
                            roomScene === _vm.selectedRoomScene
                              ? "wf-product-room-scene-image-pagination-item-button-active"
                              : "",
                          attrs: {
                            type: "button",
                            "aria-label": "View room scene number " + roomScene
                          },
                          on: {
                            click: function($event) {
                              _vm.setRoomSceneIndex(index)
                              _vm.updateQueryStringParameters(
                                _vm.$config.queryParamNames
                                  .ROOM_SCENE_QUERY_PARAM_NAME,
                                roomScene.data
                              )
                            }
                          }
                        })
                      ]
                    )
                  }),
                  0
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.productData.productTypeDesc.toLowerCase() !=
      _vm.$resourceString["productCategory.ResinousFlooring"].toLowerCase()
        ? _c(
            "div",
            {
              staticClass:
                "container-fluid d-none d-lg-block pdp-section-space pdp-section-left-space"
            },
            [
              _c("div", { staticClass: "mb-5 row" }, [
                _c("div", { staticClass: "col-lg-8" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6 col-lg-4",
                        class: {
                          expanded: _vm.expandedFormGroup === "installMethod"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "dropdown-underline font-16 pb-3" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "installation-methods-label",
                                attrs: { for: "install-method-select" }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "product.details.room.scene.installation.method"
                                      ]
                                    ) +
                                    "\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.formSelectedInstallationMethod,
                                    expression: "formSelectedInstallationMethod"
                                  }
                                ],
                                staticClass:
                                  "border-0 cursor-pointer custom-dropdown text-uppercase",
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.formSelectedInstallationMethod = $event
                                      .target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.installationMethods, function(
                                installationMethod
                              ) {
                                return _c(
                                  "option",
                                  {
                                    key: installationMethod.code,
                                    domProps: {
                                      value:
                                        installationMethod.tricycleCode ||
                                        installationMethod.code
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(installationMethod.name) +
                                        "\n                "
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6 col-lg-4",
                        class: {
                          expanded: _vm.expandedFormGroup === "changeRoom",
                          "": _vm.categoriesWithoutDuplicates.length > 0
                        }
                      },
                      [
                        _vm.categoriesWithoutDuplicates.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "dropdown-underline font-16 pb-3"
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "change-room-scene-label font-16",
                                    attrs: { for: "change-room-scene-select" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$resourceString[
                                            "product.Details.RoomSegment.Label"
                                          ]
                                        ) +
                                        ":\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedSegmentCategory,
                                        expression: "selectedSegmentCategory"
                                      }
                                    ],
                                    staticClass:
                                      "border-0 cursor-pointer custom-dropdown text-uppercase pr-2",
                                    class: {
                                      active:
                                        _vm.expandedFormGroup === "changeRoom"
                                    },
                                    attrs: { id: "change-room-scene-select" },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.selectedSegmentCategory = $event
                                            .target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                        _vm.handleMobileCategoryChange
                                      ]
                                    }
                                  },
                                  _vm._l(
                                    _vm.categoriesWithoutDuplicates,
                                    function(cat) {
                                      return _c(
                                        "option",
                                        { key: cat, domProps: { value: cat } },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(cat) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6 col-lg-4 text-right pr-0",
                        class: {
                          expanded: _vm.expandedFormGroup === "downloadImages"
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-white border-accent-gray-alt download-images-label bg-transparent",
                            attrs: { for: "download-images-select" },
                            on: {
                              click: function($event) {
                                return _vm.toggleExpanded("downloadImages")
                              }
                            }
                          },
                          [
                            _c("span", {
                              staticClass:
                                "png-icon png-icon-icons-glyph--k-btn-download mr-3"
                            }),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.Details.DownloadHD.Button"
                                  ]
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          staticClass: "swatch-viewer-modal",
          attrs: {
            top: "0",
            height: "100%",
            width: "100%",
            left: "0",
            name: "show-swatch-modal",
            "data-html2canvas-ignore": "true",
            adaptive: true,
            scrollable: true
          }
        },
        [
          _c(
            "pc-product-swatch-view-modal",
            {
              attrs: { viewMode: _vm.viewSwatch, isRug: _vm.isRug },
              on: { setViewMode: _vm.setViewMode }
            },
            [
              _vm.viewSwatch === "swatch"
                ? _c("img", {
                    staticClass: "wf-product-swatch-viewer-display zoomable",
                    attrs: {
                      src:
                        _vm.isMultitile === true
                          ? _vm.getInstallImgUrl(
                              _vm.selectedInstallationMethod.name,
                              2000
                            )
                          : _vm.$helpers.getColorThumbnailImageUrl(
                              _vm.sellingStyleNumber,
                              _vm.selectedColor.colorNumber,
                              _vm.selectedProduct.productSizeImperial
                                ? _vm.selectedProduct.productSizeImperial
                                    .toLowerCase()
                                    .replace(/ /g, "")
                                    .replace("x", "-")
                                    .replace(/[a-zA-Z]/g, "")
                                    .replace("-", "x")
                                : null,
                              _vm.productData.productTypeDesc
                            ),
                      alt: "img"
                    },
                    on: { error: _vm.handleThumbnailImageError }
                  })
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          staticClass: "download-hd-images-modal",
          attrs: {
            height: "550",
            width: "1250",
            left: "0",
            name: "show-download-view-modal",
            "data-html2canvas-ignore": "true",
            adaptive: true,
            scrollable: true
          }
        },
        [
          _c("pc-product-download-view-modal", [
            _c("div", { staticClass: "download-images-menu-content" }, [
              _c("div", { staticClass: "download-images-menu-left" }, [
                _c(
                  "ul",
                  { staticClass: "menu-ul" },
                  _vm._l(_vm.tabs, function(tab) {
                    return _c(
                      "li",
                      {
                        key: tab.name,
                        staticClass:
                          "menu-left-item dropdown-item-room-menu-left change-room-segments",
                        class: { active: _vm.selectedTab === tab },
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.selectDownloadTab(tab)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(tab.tabLinkText) +
                            "\n            "
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "download-images-dropdown-triangle" })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "download-images-menu-right" }, [
                _vm.selectedTab.name !== _vm.tabs[1].name &&
                ((_vm.selectedTab.name === _vm.tabs[2].name &&
                  _vm.roomScenes &&
                  _vm.roomScenes.length > 0) ||
                  (_vm.selectedTab.name === _vm.tabs[0].name &&
                    _vm.availableVariations &&
                    _vm.availableVariations.length > 0))
                  ? _c(
                      "div",
                      { staticClass: "download-images-menu-select-all-option" },
                      [
                        _c(
                          "label",
                          { attrs: { for: "selectallfordownloadimages" } },
                          [
                            _c("input", {
                              staticClass: "select-all-checkbox",
                              attrs: {
                                type: "checkbox",
                                id: "selectallfordownloadimages"
                              },
                              domProps: {
                                checked: _vm.getIsAllSelectedDownload
                              },
                              on: { change: _vm.downloadImagesSelectAllHandler }
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.getIsAllSelectedDownload
                                    ? _vm.$resourceString[
                                        "product.Details.DownloadImages.UnSelectAll.Label"
                                      ]
                                    : _vm.$resourceString[
                                        "product.Details.DownloadImages.SelectAll.Label"
                                      ]
                                )
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "download-images-menu-right-wrap" }, [
                  _c(
                    "ul",
                    {
                      staticClass: "menu-ul",
                      class:
                        _vm.selectedTab.name === "installation"
                          ? ""
                          : "download-images-grid mt-4"
                    },
                    [
                      _vm._l(_vm.roomScenes, function(roomScene, index) {
                        return _vm.selectedTab.name === _vm.tabs[2].name &&
                          (!_vm.hasStaticImage ||
                            index < _vm.roomScenes.length - _vm.staticCount)
                          ? _c("li", { key: roomScene.data + "_roomScene" }, [
                              _c("figure", [
                                _c(
                                  "label",
                                  { staticClass: "image-box-container" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.selectedImages,
                                          expression: "selectedImages"
                                        }
                                      ],
                                      staticClass:
                                        "image-checkbox download-checkbox",
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        value: roomScene.data,
                                        checked: Array.isArray(
                                          _vm.selectedImages
                                        )
                                          ? _vm._i(
                                              _vm.selectedImages,
                                              roomScene.data
                                            ) > -1
                                          : _vm.selectedImages
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.selectedImages,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = roomScene.data,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.selectedImages = $$a.concat(
                                                  [$$v]
                                                ))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.selectedImages = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.selectedImages = $$c
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticClass: "room-img-thumb",
                                      attrs: {
                                        src: _vm.getRoomSceneImageUrl(
                                          roomScene,
                                          180
                                        ),
                                        alt: "img"
                                      },
                                      on: {
                                        load: _vm.handleImageLoad,
                                        error: _vm.handleImageError
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "checkbox-overlay"
                                    })
                                  ]
                                )
                              ])
                            ])
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm.selectedTab.name === "installation"
                        ? _c("li", [
                            _c("figure", [
                              _c(
                                "label",
                                { staticClass: "image-box-container" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: false,
                                        expression: "false"
                                      },
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedImages,
                                        expression: "selectedImages"
                                      }
                                    ],
                                    staticClass:
                                      "image-checkbox download-checkbox",
                                    attrs: { type: "checkbox", disabled: true },
                                    domProps: {
                                      value:
                                        _vm.getdownloadInstallationMethod.name,
                                      checked: Array.isArray(_vm.selectedImages)
                                        ? _vm._i(
                                            _vm.selectedImages,
                                            _vm.getdownloadInstallationMethod
                                              .name
                                          ) > -1
                                        : _vm.selectedImages
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.selectedImages,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v =
                                              _vm.getdownloadInstallationMethod
                                                .name,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.selectedImages = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.selectedImages = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.selectedImages = $$c
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    class:
                                      _vm.selectedTab.name === "installation"
                                        ? "w-100"
                                        : "installation-img-thumb",
                                    attrs: {
                                      src: _vm.getInstallImgUrl(
                                        _vm.getdownloadInstallationMethod.name,
                                        325
                                      ),
                                      alt: "img"
                                    },
                                    on: {
                                      load: _vm.handleImageLoad,
                                      error: _vm.handleImageError
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "checkbox-overlay"
                                  })
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.availableVariations, function(variant) {
                        return _vm.selectedTab.name === _vm.tabs[0].name &&
                          _vm.availableVariations &&
                          _vm.availableVariations.length > 0
                          ? _c("li", { key: variant + "_swatchImg" }, [
                              _c("figure", [
                                _c(
                                  "label",
                                  { staticClass: "image-box-container" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.selectedImages,
                                          expression: "selectedImages"
                                        }
                                      ],
                                      staticClass:
                                        "image-checkbox download-checkbox",
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        value: variant,
                                        checked: Array.isArray(
                                          _vm.selectedImages
                                        )
                                          ? _vm._i(
                                              _vm.selectedImages,
                                              variant
                                            ) > -1
                                          : _vm.selectedImages
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.selectedImages,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = variant,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.selectedImages = $$a.concat(
                                                  [$$v]
                                                ))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.selectedImages = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.selectedImages = $$c
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticClass: "w-100 cursor-pointer",
                                      attrs: {
                                        src: _vm.getSwatchImageUrl(
                                          _vm.selectedProductWidth,
                                          _vm.selectedProductHeight,
                                          variant
                                        ),
                                        crossorigin: "anonymous",
                                        alt: "img"
                                      },
                                      on: {
                                        load: _vm.handleImageLoad,
                                        error: _vm.handleImageError
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "checkbox-overlay"
                                    })
                                  ]
                                )
                              ])
                            ])
                          : _vm._e()
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.isLoading &&
                  !(
                    _vm.selectedTab.name === _vm.tabs[0].name &&
                    (!_vm.availableVariations ||
                      _vm.availableVariations.length === 0)
                  ) &&
                  !(
                    _vm.selectedTab.name === _vm.tabs[1].name &&
                    !_vm.getInstallImgUrl(
                      _vm.getdownloadInstallationMethod.name,
                      325
                    )
                  ) &&
                  !(
                    _vm.selectedTab.name === _vm.tabs[2].name &&
                    _vm.roomScenes.length === 0
                  )
                    ? _c("div", { staticClass: "wf-load-image-status" }, [
                        _c("div", {
                          staticClass: "spinner-border",
                          attrs: { role: "status" }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedTab.name === _vm.tabs[0].name &&
                  (!_vm.availableVariations ||
                    _vm.availableVariations.length === 0)
                    ? _c(
                        "div",
                        { staticClass: "no-swatch-variations-container" },
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(
                                _vm.$resourceString[
                                  "product.Details.NoSwatch.Placeholder"
                                ]
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedTab.name === _vm.tabs[1].name &&
                  !_vm.getInstallImgUrl(
                    _vm.getdownloadInstallationMethod.name,
                    325
                  )
                    ? _c(
                        "div",
                        { staticClass: "no-swatch-variations-container" },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$resourceString[
                                  "common.NoDataAvailable.Msg"
                                ]
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedTab.name === _vm.tabs[2].name &&
                  _vm.roomScenes.length === 0
                    ? _c(
                        "div",
                        { staticClass: "no-swatch-variations-container" },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$resourceString[
                                  "common.NoDataAvailable.Msg"
                                ]
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "spinner d-none",
                  attrs: { id: "wf-download-modal-spiner" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "spinner-border",
                      attrs: { role: "status" }
                    },
                    [
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$resourceString[
                              "product.Details.Loading.Placeholder"
                            ]
                          )
                        )
                      ])
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "row mb-3 mt-3 download-images-menu-content-footer"
              },
              [
                _c("div", { staticClass: "col-md-1 col-lg-3" }),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-5 col-lg-4 ml-3" }, [
                  _vm.selectedTab.name === _vm.tabs[1].name &&
                  _vm.productData.productTypeDesc.toLowerCase() !=
                    _vm.$resourceString[
                      "productCategory.ResinousFlooring"
                    ].toLowerCase()
                    ? _c(
                        "div",
                        { staticClass: "dropdown-underline font-16 pb-3" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "installation-methods-label",
                              attrs: { for: "install-method-select" }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$resourceString[
                                      "product.details.room.scene.installation.method"
                                    ]
                                  ) +
                                  " :\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.downloadInstallationMethod,
                                  expression: "downloadInstallationMethod"
                                }
                              ],
                              staticClass:
                                "border-0 cursor-pointer font-weight-bold custom-dropdown text-uppercase",
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.downloadInstallationMethod = $event.target
                                    .multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            _vm._l(_vm.installationMethods, function(
                              installationMethod
                            ) {
                              return _c(
                                "option",
                                {
                                  key: installationMethod.code,
                                  domProps: {
                                    value:
                                      installationMethod.tricycleCode ||
                                      installationMethod.code
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(installationMethod.name) +
                                      "\n            "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-5 col-lg-4" }, [
                  (_vm.selectedTab.name !== _vm.tabs[0].name &&
                    _vm.selectedInstallationMethod.name
                      .toLowerCase()
                      .includes("reverse")) ||
                  !_vm.selectedInstallationMethod.name
                    .toLowerCase()
                    .includes("reverse")
                    ? _c("div", { staticClass: "download-button-container" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-hd-img-download text-uppercase border border-accent-gray-alt w-65 justify-content-start font-weight-bold",
                            class:
                              _vm.selectedImages &&
                              _vm.selectedImages.length == 0
                                ? "btn-light"
                                : "btn-white",
                            attrs: {
                              disabled:
                                _vm.selectedImages &&
                                _vm.selectedImages.length == 0
                            },
                            on: {
                              click: function($event) {
                                _vm.downloadImages(),
                                  _vm.toggleExpanded("downloadImages")
                              }
                            }
                          },
                          [
                            _c("span", {
                              staticClass:
                                "png-icon png-icon-icons-glyph--k-btn-download mr-3"
                            }),
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.Details.DownloadHD.Button"
                                  ]
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("pc-product-swatch-roomscene-view-hero-modal", {
        attrs: {
          updateQueryStringParameters: _vm.updateQueryStringParameters,
          expandedFormGroup: _vm.expandedFormGroup,
          installationMethods: _vm.installationMethods,
          product: _vm.product,
          segments: _vm.segments,
          segmentrooms: _vm.segmentrooms,
          collectionsegments: _vm.collectionsegments,
          roomscenenumbers: _vm.roomscenenumbers,
          segmentRoomScenes: _vm.segmentRoomScenes,
          mappedColors: _vm.mappedColors,
          hideModal: _vm.productRoomSceneCloseModal,
          viewProductType: _vm.viewProductType,
          isMultitile: _vm.isMultitile,
          toggleModeForProductImage: _vm.toggleMode,
          getInstallImgUrl: _vm.getInstallImgUrl,
          getRoomSceneImageUrl: _vm.getRoomSceneImageUrl,
          hideSwatchMultiTileButtons: _vm.hideSwatchMultiTileButtons,
          videoURL: _vm.videoURL
        },
        on: { "color-changed": _vm.updateColor }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }